<template lang="pug">
  a.button(:href="href", :class="buttonClass", :disabled="disabled")
    icon(v-if="icon", :name="icon", :size="iconSize")
    span {{ label }}
    span {{ price }}
</template>

<script>
  import Icon from '../basic/Icon.vue'
  import LinkButton from './LinkButton.vue'

  export default {
    extends: LinkButton,
    components: { Icon },
    name: 'CheckoutLinkButton',
    props: {
     price: {
        type: String,
        default: ''
      }
    }
  }
</script>

<style scoped lang="scss">
  .icon {
    position: initial;
    transform: none;
    margin-bottom: 4px;
  }
</style>